const MENU_NAME = 'buildings';

class BuildingsTopNav {
    constructor($window, $timeout, $rootScope, $templateCache) {
        this.$window = $window;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$templateCache = $templateCache;

        this.scope = {
            buildings: '=',
            selectedBuilding: '='
        };

        this.template = this.getTemplate();
        this.link = this.BuildingsTopNavLink;
    }

    getTemplate() {
        const template = this.$templateCache.get('nav-bar/top/buildings-top-nav-tmpl.html');
        return template;
    }

    BuildingsTopNavLink(scope, element, attrs) {
        const { buildings } = scope;

        scope.buildings = this._mapBuildings(buildings);
        this.init(scope, element);
    }

    init(scope, element) {
        scope.isOpen = false;

        scope.toggleBuildingList = () => {
            scope.isOpen = !scope.isOpen;
            if (scope.isOpen) {
                this.$rootScope.$broadcast('mobile-menu-opened', MENU_NAME);
            }
        };

        scope.selectedBuildingName = () => {
            const selected = (scope.buildings || []).find(b => b.SchemeReference === scope.selectedBuilding);
            return selected ? selected.SchemeName : '';
        };

        scope.changeBuilding = (building) => {
            scope.isOpen = false;
            scope.$emit('selected-building-changed', building.SchemeReference);
            this.$rootScope.$broadcast('reload-user-units', building.SchemeName);
        };

        const offMenuOpened = this.$rootScope.$on('mobile-menu-opened', (event, name) => {
            if (name !== MENU_NAME) {
                scope.isOpen = false;
            }
        });
        scope.$on('$destroy', offMenuOpened);
    }

    _mapBuildings(original) {
        if (!!!original || original.length === 0) {
            return null;
        }

        let mapped = original.map((building) => {
            return {
                ...building,
                isSelected: false
            };
        });
        return mapped;
    }
}

export default /* @ngInject */ ($window, $timeout, $rootScope, $templateCache) =>
    new BuildingsTopNav($window, $timeout, $rootScope, $templateCache);
